<template>
  <div class="c-app c-default-layout flex-row align-items-center page-403">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="6">
          <CCardGroup>
            <CCard class="p-4 shadow-sm border-0">
              <CCardBody class="text-center">
                <div class="display-3 text-warning mb-3">403</div>
                <h3 class="mb-3">No Permission</h3>
                <p class="text-muted mb-4">คุณไม่มีสิทธิ์เข้าถึงหน้านี้</p>
                <CButton color="warning" to="/logout">
                  กลับไปหน้าเข้าสู่ระบบ
                </CButton>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
export default {
  name: "Page403"
}
</script>

<style scoped>
.page-403 {
  min-height: 100vh;
  background: linear-gradient(135deg, #fff7e6 0%, #f8fafc 100%);
}
</style>
